import React, { useState } from "react";
import { Button, Select, Card, Flex, Space, Divider } from "antd";
import Announcement from "./announcement";
import PostComponent from "./post";
import PollComponent from "./poll";
import PraiseComponent from "./praise";

const PostSections: React.FC = () => {
    const [activeTab, setActiveTab] = useState("Post");

    const postTabs: { key: string; label: string; content: React.ReactNode }[] = [
        {
            key: 'Post',
            label: 'Post',
            content: <PostComponent />
        },
        {
            key: 'Announcement',
            label: 'Announcement',
            content: <Announcement />
        },
        {
            key: 'Poll',
            label: 'Poll',
            content: <PollComponent />
        },
        {
            key: 'Praise',
            label: 'Praise',
            content: <PraiseComponent />
        },
    ]

    const onChangeTab = (key: string) => {
        setActiveTab(key)
    }

    const actions: React.ReactNode[] = [<Flex justify="space-between" gap={8}>
        <Select placeholder="Select target">
            <Select.Option value="organization">Organization</Select.Option>
            <Select.Option value="team">Team</Select.Option>
        </Select>
        <Space direction="horizontal">
            <Button>Cancel</Button>
            <Button type="primary">Save</Button>
        </Space>
    </Flex>]

    return (
        <Card
            tabList={postTabs}
            onTabChange={onChangeTab}
            size="small"
        >
            {postTabs.filter(e => e.key == activeTab)[0].content}
            <Divider />
            <Flex justify="space-between" gap={8}>
                <Select placeholder="Select target">
                    <Select.Option value="organization">Organization</Select.Option>
                    <Select.Option value="team">Team</Select.Option>
                </Select>
                <Space direction="horizontal">
                    <Button>Cancel</Button>
                    <Button type="primary">Save</Button>
                </Space>
            </Flex>
        </Card >
    );
};

export default PostSections;
